import { render, staticRenderFns } from "./qushi1.vue?vue&type=template&id=633cf266&scoped=true&"
import script from "./qushi1.vue?vue&type=script&lang=js&"
export * from "./qushi1.vue?vue&type=script&lang=js&"
import style0 from "./qushi1.vue?vue&type=style&index=0&id=633cf266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cf266",
  null
  
)

export default component.exports